import React from 'react';

const IconRightArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16">
    <path fill="none" stroke="#33323D" d="M1 0l8 8-8 8" />
  </svg>
);

export default IconRightArrow;
